/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPasswordResetRequest
 */
export interface RequestPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordResetRequest
     */
    email: string;
}

/**
 * Check if a given object implements the RequestPasswordResetRequest interface.
 */
export function instanceOfRequestPasswordResetRequest(value: object): value is RequestPasswordResetRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RequestPasswordResetRequestFromJSON(json: any): RequestPasswordResetRequest {
    return RequestPasswordResetRequestFromJSONTyped(json, false);
}

export function RequestPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPasswordResetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

  export function RequestPasswordResetRequestToJSON(json: any): RequestPasswordResetRequest {
      return RequestPasswordResetRequestToJSONTyped(json, false);
  }

  export function RequestPasswordResetRequestToJSONTyped(value?: RequestPasswordResetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

